import { Component } from '@angular/core';
import { UserlaneService } from 'src/app/core/userlane/userlane.service';

@Component({
  selector: 'app-userlane-button',
  templateUrl: './userlane-button.component.html',
  styleUrls: ['./userlane-button.component.scss'],
})
export class UserlaneButtonComponent {
  constructor(private userlaneService: UserlaneService) {}

  openUserlane() {
    this.userlaneService.openUserlane();
  }
}
